import { render, staticRenderFns } from "./ImportLogisticSubscribe.vue?vue&type=template&id=c6a0d0f2"
import script from "./ImportLogisticSubscribe.vue?vue&type=script&lang=js"
export * from "./ImportLogisticSubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports